import { type ComputedRef, computed } from 'vue';
import {
  canRetryMixedItem,
  isMixedItemReady,
  type MixedPortraitGalleryItem,
  mixedItemCopyKey,
  mixedItemRatio,
} from './classic-mixed-portrait-gallery';

export interface MixedItemView {
  canRetry: ComputedRef<boolean>;
  copyKey: (key: string) => string;
  orientation: ComputedRef<'landscape' | 'portrait'>;
  ratio: ComputedRef<number>;
  ready: ComputedRef<boolean>;
}

export function useMixedItemView(
  item: () => MixedPortraitGalleryItem
): MixedItemView {
  const ratio = computed(() => mixedItemRatio(item()));
  const orientation = computed(() =>
    ratio.value >= 1 ? 'landscape' : 'portrait'
  );
  const canRetry = computed(() => canRetryMixedItem(item()));
  const ready = computed(() => isMixedItemReady(item()));

  function copyKey(key: string): string {
    return mixedItemCopyKey(item(), key);
  }

  return { canRetry, copyKey, orientation, ratio, ready };
}
